import constants from "../utils/constants";
const { ROLE_IDS } = constants;
const { SUPER_ADMIN, ADMIN, FREELANCER, CLIENT, EDITOR, MANAGER, CLIENT_AI_BOT } = ROLE_IDS;

const roleTransformer = (role = "", size = 12) => {
  switch (role) {
    case SUPER_ADMIN:
      return <span className="role">Super Admin</span>;

    case ADMIN:
      return <span className="role">Admin</span>;

    case FREELANCER:
      return <span className="role">Writer</span>;

    case CLIENT:
      return <span className="role">Client</span>;
    case EDITOR:
      return <span className="role">Editor</span>;
    case MANAGER:
      return <span className="role">Manager</span>;
    case CLIENT_AI_BOT:
      return <span className="role">Client Bot</span>;

    default:
      return <span className="role">{role}</span>;
  }
};
export default roleTransformer;
